module.exports = __webpack_public_path__ + "static/media/intelligent-store-white.1611f650.svg";